/* SSM — mobile navigation drawer + drill-in sub-panels (<=989px).
   Slide-in drawer (left), drill-in sub-panels (right), body scroll lock,
   focus trap, Escape layering (sub first, then drawer), keyboard.
   Animations are CSS; this only toggles classes. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ssm]');
  if (!root) return;

  var drawer = root.querySelector('[data-ssm-drawer]');
  var backdrop = root.querySelector('[data-ssm-backdrop]');
  var openBtn = root.querySelector('[data-ssm-open]');
  var ANIM_MS = 320;
  var lastFocus = null;
  var currentSub = null;

  function focusables(container) {
    return Array.prototype.slice
      .call(container.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'
      ))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    backdrop.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('ssm-open');
    });
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var f = focusables(drawer);
    if (f.length) f[0].focus();
  }

  function closeDrawer() {
    if (currentSub) closeSub(true);
    root.classList.remove('ssm-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!root.classList.contains('ssm-open')) backdrop.hidden = true;
    }, ANIM_MS);
    if (lastFocus) lastFocus.focus();
  }

  function openSub(id) {
    var panel = document.getElementById(id);
    var trig = root.querySelector('[data-ssm-sub="' + id + '"]');
    if (!panel) return;
    panel.classList.add('is-open');
    // Commit the start state (display:flex + translateX(100%)) before transitioning
    // in, otherwise the panel can paint at its end position for one frame (flicker).
    void panel.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { panel.classList.add('is-anim'); });
    });
    if (trig) trig.setAttribute('aria-expanded', 'true');
    currentSub = id;
    var f = focusables(panel);
    if (f.length) f[0].focus();
  }

  function closeSub(skipFocus) {
    if (!currentSub) return;
    var panel = document.getElementById(currentSub);
    var trig = root.querySelector('[data-ssm-sub="' + currentSub + '"]');
    if (panel) {
      panel.classList.remove('is-anim');
      setTimeout(function () {
        if (!panel.classList.contains('is-anim')) panel.classList.remove('is-open');
      }, ANIM_MS);
    }
    if (trig) {
      trig.setAttribute('aria-expanded', 'false');
      if (!skipFocus) trig.focus();
    }
    currentSub = null;
  }

  openBtn.addEventListener('click', openDrawer);
  backdrop.addEventListener('click', closeDrawer);

  Array.prototype.forEach.call(root.querySelectorAll('[data-ssm-close]'), function (el) {
    el.addEventListener('click', closeDrawer);
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-ssm-sub]'), function (t) {
    t.addEventListener('click', function () { openSub(t.getAttribute('data-ssm-sub')); });
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-ssm-back]'), function (b) {
    b.addEventListener('click', function () { closeSub(); });
  });

  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('ssm-open')) return;

    if (e.key === 'Escape') {
      if (currentSub) closeSub(); else closeDrawer();
      return;
    }
    if (e.key === 'Tab') {
      var layer = currentSub ? document.getElementById(currentSub) : drawer;
      var f = focusables(layer);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
